import React, { Component } from 'react';

class Sidebar extends Component {
    render() {
        
        return (
            <div className="sidebar">
                <div className="subLogo">
                    
                </div>
            </div>
        );
    }
}

export default Sidebar;


// WEBPACK FOOTER //
// ./src/components/Sidebar.js